import { Component } from '@angular/core';
import { TourismEventsComponent } from '../tourism-events.common';
import { Permissions } from '@/common/enums/Permissions';

@Component({
	selector: 'app-tourism-events-rent',
	templateUrl: './tourism-events-rent.component.html',
	styleUrls: ['./tourism-events-rent.component.css'],
})
export class TourismEventsRentComponent extends TourismEventsComponent {
	errors = {
		name: '',
		vehicles: [],
		owner: '',
		date_from: '',
		date_to: '',
		startDate: '',
		category: '',
		people: '',
		startPlace: '',
		endDate: '',
		endPlace: '',
		clientEvent: null,
	};

	readonly Permissions = Permissions;

	protected defaultValues(): void {
		this.event.status = 'PRELIMINARY';
		this.event.type = 'EVENT';
		this.event.category = this.route.snapshot.params['category'];
	}
}
